import api from "./api";

export const extraerItemsReglas = (raw) => {
    if (Array.isArray(raw)) return raw;
    return raw?.data || raw?.reglas || raw?.items || raw?.content || [];
};

// Crear regla en reglas_data
export const crearReglaPrestacion = async (payload) => {
    const response = await api.post("/v1/reglas", payload);
    return response.data;
};

// Actualizar una regla existente
export const actualizarReglaPrestacion = async (ruleId, payload) => {
    const response = await api.put(`/v1/reglas/${encodeURIComponent(ruleId)}`, payload);
    return response.data;
};

// Deshabilitar una regla
export const deshabilitarRegla = async (ruleId) => {
    const response = await api.patch(`/v1/reglas/${encodeURIComponent(ruleId)}/deshabilitar`);
    return response.data;
};

// Obtener reglas paginadas
// Responde tanto si el backend devuelve un array (legado) como { data, total } (paginado)
// signal: AbortController.signal para cancelar requests en vuelo
export const obtenerTodasLasReglas = async ({ page = 1, pageSize = 50, search = '', accion = '', vigencia = '', sortBy = '', sortDir = 'asc', signal } = {}) => {
    const params = { page, pageSize };
    if (search) params.search = search;
    if (accion) params.accion = accion;
    if (vigencia) params.vigencia = vigencia;
    if (sortBy) { params.sortBy = sortBy; params.sortDir = sortDir; }
    const response = await api.get("/v1/reglas", { params, signal });
    return response.data;
};

// Obtener una regla por ID
export const obtenerReglaPorId = async (ruleId) => {
    const response = await api.get(`/v1/reglas/${encodeURIComponent(ruleId)}`);
    return response.data;
};

export const obtenerRelacionInversaRegla = async (ruleId, { signal } = {}) => {
    try {
        const response = await api.get(`/v1/reglas/${encodeURIComponent(ruleId)}/relacion-inversa`, { signal });
        return response.data;
    } catch (error) {
        if (error?.response?.status === 404) {
            return {
                currentRuleId: String(ruleId || ""),
                parejaRuleId: null,
                esActualInversa: false,
                parejaActiva: false,
                parejaRule: null,
            };
        }
        throw error;
    }
};

export const validarDuplicadoExactoRegla = async (payload) => {
    try {
        const response = await api.post("/v1/reglas/validaciones/duplicado-exacto", payload);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 404) {
            return {
                duplicado: false,
                reglaDuplicada: null,
            };
        }
        throw error;
    }
};

export const obtenerReglasPorTipo = async (tipoRegla) => {
    const response = await api.get(`/v1/reglas/tipo/${encodeURIComponent(tipoRegla)}`);
    return response.data;
};

export const obtenerContextoPrioridadRegla = async (params) => {
    const response = await api.get("/v1/reglas/prioridad-contexto", { params });
    return response.data;
};

// Eliminar una regla
export const eliminarRegla = async (ruleId, ruleIdMotor) => {
    const query = ruleIdMotor ? `?ruleId=${encodeURIComponent(ruleIdMotor)}` : "";
    const response = await api.delete(`/v1/reglas/${encodeURIComponent(ruleId)}${query}`);
    return response.data;
};

export const obtenerAcciones = async () => {
    const response = await api.get("/v1/acciones");
    return response.data.map(acc => ({
        ...acc,
        value: acc.codigo,
        label: acc.descripcion
    }));
};

export const obtenerAtributos = async () => {
    const response = await api.get("/v1/atributos");
    return response.data.map(acc => ({
        ...acc,
        value: acc.nombre,
        label: acc.descripcion
    }));
};

export const obtenerOperadores = async () => {
    const response = await api.get("/v1/operadores");
    return response.data.map(op => ({
        ...op,
        value: op.nombre,
        label: op.descripcion
    }));
};

export const obtenerTiposRegla = async () => {
    const response = await api.get("/v1/tipos-regla");
    return response.data.map(acc => ({
        ...acc,
        value: acc.codigo,
        label: acc.descripcion
    }));
};

export const obtenerAlcances = async () => {
    const response = await api.get("/v1/alcances");
    return response.data.map(acc => ({
        ...acc,
        value: acc.nombre,
        label: acc.descripcion
    }));
};

export const obtenerCatalogoCondicionesMedicas = async () => {
    const response = await api.get("/condicion");
    return (response.data || []).map((condicion) => {
        const codigo = String(condicion?.codigo || "").trim();
        const descripcion = String(condicion?.descripcionDiagnostico || "").trim();
        return {
            ...condicion,
            value: codigo,
            label: descripcion ? `${codigo} - ${descripcion}` : codigo,
        };
    }).filter((condicion) => condicion.value);
};
